"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    'Archery',
    'Badminton',
    'Baseball',
    'Basketball',
    'Bowling',
    'Boxing',
    'Cheerleading',
    'Cricket',
    'Cross-country',
    'Diving',
    'Equestrian',
    'Fencing',
    'Field Hockey',
    'Football',
    'Football (non-tackle)',
    'Golf',
    'Gymnastics',
    'Handball',
    'Ice Hockey',
    'Indoor Track',
    'Judo',
    'Lacrosse',
    'Outdoor Track',
    'Racquetball',
    'Rifle',
    'Rodeo',
    'Rowing (Crew)',
    'Rugby',
    'Sailing',
    'Skiing',
    'Skin Diving',
    'Soccer',
    'Softball',
    'Squash',
    'Swim',
    'Sync. Swimming',
    'Table Tennis',
    'Tennis',
    'Track and Field',
    'Triathlon',
    'Volleyball',
    'Water Polo',
    'Weight Lifting',
    'Wrestling',
    'Other Sport',
];
//# sourceMappingURL=ecSportsAndTeams.js.map